import styled from 'styled-components';
import { vars, media, pxToRem } from '$util/theme';

export const Styled = styled.div`
  color: ${vars.quantumverse.reskinColors.neutral700};
  font-weight: ${vars.fontWeight.regular};

  .card {
    background-color: ${vars.quantumverse.reskinColors.white};
    padding: 24px 16px;
    border: 1px solid ${vars.quantumverse.reskinColors.neutral200};
    box-shadow: 0px 2px 16px 0px rgba(22, 29, 36, 0.08);
    ${media.up('md')} {
      padding: 24px 20px;
    }
  }

  .title {
    font-size: ${pxToRem(22)};
    font-weight: ${vars.fontWeight.semiBold};
    letter-spacing: -0.48px;
  }

  .input-group {
    display: grid;
    grid-template-columns: 1fr;
    align-items: flex-start;
    gap: 16px;

    ${media.up('md')} {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
    }

    .FormItem {
      margin: 0 !important;
    }
  }

  .-error {
    label {
      color: ${vars.red};
    }
    .item-error {
      color: ${vars.red};
      font-size: ${pxToRem(13)};
    }
  }

  .anticon-check-circle {
    display: none;
  }

  .description {
    font-family: 'Rubik';
    padding-top: 9px;
    font-size: ${pxToRem(13)};
    line-height: 16px;
    color: ${vars.quantumverse.reskinColors.neutral300};
  }

  .purchase-order {
    padding-top: 5px;
  }

  .marketing {
    display: flex;
    gap: 11px;
    align-items: center;

    input[type='checkbox'] {
      display: none;
    }

    input[type='checkbox'] + label {
      position: relative;
      padding-left: 30px;
      cursor: pointer;
      display: inline-block;
      top: -12px;
    }

    input[type='checkbox'] + label:before {
      content: '';
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      left: 0;
      border: 1px solid ${vars.quantumverse.reskinColors.neutral200};
      border-radius: ${vars.quantumverse.borderRadius.borderRadius6};
      background-color: ${vars.quantumverse.reskinColors.white};
    }

    input[type='checkbox']:checked + label:before {
      background-color: ${vars.quantumverse.reskinColors.purple500};
      border-color: ${vars.quantumverse.reskinColors.purple500};
    }

    input[type='checkbox']:checked + label:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      background: url(https://res.cloudinary.com/fxtr/image/upload/v1624896300/digital-sheets/common/Green_Check_2x_yd3ult.png)
        no-repeat;
      background-size: contain;
      border-radius: ${vars.quantumverse.borderRadius.borderRadius6};
    }
  }

  .terms {
    margin-top: 24px;
    p {
      font-size: ${pxToRem(12)};
      line-height: ${pxToRem(20)};
    }
    a {
      color: ${vars.quantumverse.reskinColors.purple500} !important;
    }
  }

  .Banner {
    position: fixed;
    z-index: 10000;
    width: 100%;
    top: 0px;
    left: 0px;
    font-weight: ${vars.fontWeight.regular};
    .login-error {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .btn-link {
        text-decoration-color: ${vars.quantumverse.reskinColors.white};
        > span {
          color: ${vars.quantumverse.reskinColors.white};
        }
      }
    }
  }
`;
